import "./patientMeasurement.scss";
import "../../steps/forms.scss";
import FormTitle from "../../components/formTitle/FormTitle";
import MuiRadio from "../../components/radio/MuiRadio";
import InputTextField from "../../components/textField/InputTextField";
import OrderFormStep from "../../common/OrderFormStep";
import FieldState from "../../common/FieldState";
import apiClient from "../../common/apiClient";
import Config from "../../common/Config";
import Button from "../../components/button/Button";
import { Button as MuiButton } from "@mui/material";
import SecondaryButton from "../../components/button/SecondaryButton";
import { CreateNotification } from "../../components/notification/Notification";
import SaveAsDraft from "../../components/modal/SaveAsDraft";
import ClearOrder from "../../components/modal/ClearOrder";
import { FileUploadIcon } from "../../icons/svg";
import { AreNotesLessThanMaxLength, MaxInputLength, OnFileChange } from '../../common/common';

class XtremityMeasurement extends OrderFormStep {
  constructor(props) {
    super(props);

    this.fromCADFileId = 183;
    this.fromCastId = 182;

    this.nextCartQueueIndex=0;
    this.displayedCartIndex=0;

    this.defaults = {
      socketFinish: {name: "Black Carbon Applique", id: 181},
    }; 

    this.state = {
      estimatedShipDate: null,
      socketMaterials: [],
      insertMaterials: [],
      suspensionOptions: [],
      trimlineOptions: [],
      isSubmit: false,
      selectedValue: 0,
      patientId: null,
      formState: {
        cadFile: new FieldState(false),
        cadFileName: new FieldState(false),
        castShippedSeparately: new FieldState(false),
        scanFileName: new FieldState(false),
        socketMaterial: new FieldState(true),
        insertMaterial: new FieldState(false),
        suspension: new FieldState(true),
        trimline: new FieldState(true),
        itemsSentIn: new FieldState(true),
        notes: new FieldState(false),
      },
    };

    this.onCheckChange = this.onCheckChange.bind(this);
    this.getNextCartQueueIndex = this.getNextCartQueueIndex.bind(this);
    this.shouldDisplayCart = this.shouldDisplayCart.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.addFile = this.addFile.bind(this);
  }

  getNextCartQueueIndex() {
    return this.nextCartQueueIndex++;
  }

  shouldDisplayCart(index) {
    if(index >= this.displayedCartIndex) {
      this.displayedCartIndex = index;
      return true;
    }

    return false;
  }

  
  loadCart() {
    let cart = [];

    let addToCart = (options, selectedId, sourceId) => {
      let item = options.filter(x => x.id===selectedId)[0];
      if(item && item.partNumbers && item.partNumbers.length > 0) {
        item.partNumbers.forEach(part => {
          cart.push({
            name: item.displayName,
            partNumber: part,
            quantity: 1,
            price: -1,
            sourceId: sourceId
          });
        });
      } else {
        cart.push({
            name: null,
            partNumber: null,
            quantity: 0,
            price: 0,
            sourceId: sourceId
          });
      }
    }


    addToCart(this.state.socketMaterials, this.state.formState.socketMaterial.value, "socketMaterial");
    addToCart(this.state.suspensionOptions, this.state.formState.suspension.value, "suspension");
    addToCart(this.state.trimlineOptions, this.state.formState.trimline.value, "trimline");

    for (let i = 0; i < this.state.insertMaterials.length; i++) {
      let fieldOptionId = this.state.insertMaterials[i].id;

      if(this.state.formState.insertMaterial.value[fieldOptionId]) {
        addToCart(this.state.insertMaterials, fieldOptionId, ""+fieldOptionId);
      } else {
        addToCart(this.state.insertMaterials, null, ""+fieldOptionId);
      }
    }
    
    let config = {};
    config.params = {
      cart: cart.map(x => x.partNumber)
    }

    const index = this.getNextCartQueueIndex();

    return this.loadShipDate()
      .then(r1 => {
        return apiClient.get("price/" + this.props.formTypeId,
          config
        ).then(response => {
          let data = response.data
  
          cart = cart.map(c => {
            return {
              name: c.name,
              partNumber: c.partNumber,
              quantity: c.quantity,
              price: data.filter(x => x.partNumber === c.partNumber)[0]?.price,
              sourceId: c.sourceId
            }
          });

          cart = cart.concat(data.filter(d => d.sourceId !== null).map(d => {
            return {
              name: d.name,
              partNumber: d.partNumber,
              quantity: d.quantity,
              price: d.price,
              sourceId: d.sourceId
            }
          }));
          
          if(this.shouldDisplayCart(index)) {
            this.props.setTempCart(cart);
          }
        }).catch(error =>{
          console.log(error)
        })
      });
  }

  isFromCADFileSelected() {
    return this.state.formState.socketMaterial.value === this.fromCADFileId;
  }

  onCheckChange(e) {
    let formState = this.state.formState;
    formState.castShippedSeparately.value = e.target.checked;
    this.setState({ formState: formState, hasDataChanged: true });
  }

  componentDidMount() {
    this.loadData();
  }

  async loadShipDate() {
    try {
      let estimatedShipDate = (
        await apiClient.get("shipDate/" + this.props.formTypeId)
      ).data;

      this.setState({
        estimatedShipDate: estimatedShipDate,
      });
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    this.setState({ isLoaded: true });
  }

  async loadData() {
    try {
      this.setState({

        socketMaterials: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "socketMaterial" } }
          )
        ).data,

        insertMaterials: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "insertMaterial" } }
          )
        ).data,

        suspensionOptions: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "xtremitySuspension" } }
          )
        ).data,

        trimlineOptions: (
          await apiClient.get("fieldOptions/" + this.props.formTypeId,
            { params: { fieldName: "trimline" } }
          )
        ).data,
      });

      let formState = this.state.formState;
      let headers = {
      };
      let cadFileConfig = {
        headers: headers,
      };

      const cadFile = (
        await apiClient.get("cadFiles/" + this.props.formTypeId,
          cadFileConfig
        )
      ).data;
      formState.cadFileName.value = cadFile !== null ? cadFile.cadFileName : "";

      let patientInfo1Config = {
        headers: {},
        params: {
          fieldNames: ["patientInfo1UOM", "height", "weight"],
        },
      };

      if (this.props.uniqueId != null) {
        patientInfo1Config.headers.UniqueId = this.props.uniqueId;
      }

      let patientInfo1Data = (
        await apiClient.get("patientInfo1s/" + this.props.formTypeId,
          patientInfo1Config
        )
      ).data.patientId;

      this.setState({
        patientId: patientInfo1Data
      })

      this.loadShipDate();
      let config = {
        headers: headers,
        params: {
          fieldNames: [
            "scanFileName",
            "socketMaterial",
            "insertMaterial",
            "xtremitySuspension",
            "socketFinish",
            "trimline",
            "itemsSentIn",
            "notes",
          ],
        },
      };

      const { data } = await apiClient.get("fieldInputs/" + this.props.formTypeId,
        config
      );

      formState.socketMaterial.value = data.find(
        (fi) => fi.fieldName === "socketMaterial"
      ).fieldOptionId;

      formState.suspension.value = data.find(
        (fi) => fi.fieldName === "xtremitySuspension"
      ).fieldOptionId;

      formState.trimline.value = data.find(
        (fi) => fi.fieldName === "trimline"
      ).fieldOptionId;


      formState.itemsSentIn.value = data.find(
        (fi) => fi.fieldName === "itemsSentIn"
      ).stringData;
      formState.notes.value = data.find(
        (fi) => fi.fieldName === "notes"
      ).stringData;

      for (let i = 0; i < this.state.insertMaterials.length; i++) {
        let fieldOptionId = this.state.insertMaterials[i].id;
        let fieldInput = data.find(
          (fi) =>
            fi.fieldName === "insertMaterial" &&
            fi.fieldOptionId === fieldOptionId
        );

        if (fieldInput !== undefined) {
          formState.insertMaterial.value[fieldOptionId] =
            fieldInput.booleanData;
        } else {
          formState.insertMaterial.value[fieldOptionId] = false;
        }
      }

      formState.cadFileName.isRequired = this.isFromCADFileSelected();
      formState.scanFileName.isRequired = this.isFromScanSelected();

      this.setState({ formState: formState });

      this.loadCart();
    } catch (error) {
      //   this.props.handleError(new LoadFailureResult());
    }
    

    this.setState({ isLoaded: true });
  }

  getFieldInputPromise() {

    let fieldInputData = [];

    fieldInputData.push({
      fieldName: "socketFinish",
      fieldOptionId: this.defaults.socketFinish.id,
    });

    fieldInputData.push({
      fieldName: "itemsSentIn",
      stringData: this.state.formState.itemsSentIn.value,
    });

    fieldInputData.push({
      fieldName: "notes",
      stringData: this.state.formState.notes.value,
    });


    fieldInputData.push({
      fieldName: "socketMaterial",
      fieldOptionId: this.state.formState.socketMaterial.value,
    });

    fieldInputData.push({
      fieldName: "xtremitySuspension",
      fieldOptionId: this.state.formState.suspension.value,
    });

    fieldInputData.push({
      fieldName: "trimline",
      fieldOptionId: this.state.formState.trimline.value,
    });


    for (let i = 0; i < this.state.insertMaterials.length; i++) {
      let fieldOptionId = this.state.insertMaterials[i].id;

      fieldInputData.push({
        fieldName: "insertMaterial",
        fieldOptionId: fieldOptionId,
        booleanData: this.state.formState.insertMaterial.value[fieldOptionId] ?? false,
      });
    }

    return apiClient.post("fieldInputs/" + this.props.formTypeId,
      fieldInputData
    )
  }

  saveData() {

    let promises = [];

    if (this.state.formState.cadFile.value !== "" && this.isFromCADFileSelected()) {
      const formData = new FormData();

      formData.append(
        "cadFile",
        this.state.formState.cadFile.value,
        this.state.formState.cadFile.value.name
      );

      promises.push(
        apiClient.post("cadFiles/" + this.props.formTypeId,
          formData
        )
      );
    }

    if (this.state.formState.cadFileName.value != "" && !this.isFromCADFileSelected())
    {
      const formData = new FormData();

      formData.append(
        "cadFile",
        null,
      );

      promises.push(
        apiClient.put("cadFiles/" + this.props.formTypeId, formData)
      );
    }

    if (this.validateData().isValid) {
      promises.push(this.getFieldInputPromise());
      Promise.all(promises)
        .then(
          ([res, res2]) => {
            if (res2) {
              if (
                (res.status === 200 || res.status === 204) &&
                (res2.status === 200 || res2.status === 204)
              ) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
              }
            } else {
              if (res.status === 200 || res.status === 204) {
                this.props.handleNext(this?.props?.currentIndex);
                this.setState({ isLoading: false });
              }
            }
          })
        .catch((error) => {
          console.log(error);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({
        isSubmit: true,
      });
      CreateNotification(this.validateData().errorMessage, "error");
      this.setState({ isLoading: false });
    }
  }

  formatShipDate(shipDate) {
    if (!shipDate) {
      return "";
    }
    return `${shipDate.month}/${shipDate.day}/${shipDate.year}`;
  }

  handleSliderChange(newValue) {
    this.props.setActiveInnerStep(5);
  }

  handleError(id) {
    const { formState } = this.state;
    const errorClass =
      formState[id].isRequired &&
      (formState[id].value === "" ||
        formState[id].value === 0 ||
        formState[id].value === null);
    return errorClass ? true : false;
  }

  convertToISOString(dateString) {
    const dateParts = dateString.split("-");
    const convertedDate = new Date(
      dateParts[0],
      dateParts[1] - 1,
      dateParts[2]
    );

    return convertedDate;
  }
  formatDateToString(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  removeFile() {
    this.state.formState.cadFile.isRequired = false;
    this.state.formState.cadFileName.isRequired = false;
    this.setState({ formState: this.state.formState, hasDataChanged: true });
  }

  addFile() {
    if (this.state.formState.cadFileName.value !== "") {
      this.state.formState.cadFileName.isRequired = false;
    } else {
      this.state.formState.cadFileName.isRequired = true;
    }
    this.setState({ formState: this.state.formState, hasDataChanged: true });
  }

  render() {
    if (!this.state.isLoaded) return this.makeLoadingText();

    const cadFileUploader = (
      <div className="fileUpload">
        <span>Upload .stl, .obj or .aop <span className="red-emphasis">*</span></span>
        <span>Max file size: 10MB</span>
        <MuiButton
          component="label"
          variant="contained"
          startIcon={<FileUploadIcon />}
        >
          Upload File
          <input
            type="file"
            style={{ display: "none" }}
            onChange={(e) => OnFileChange(e, this)}
          />
        </MuiButton>
        <span>{this.state.formState.cadFileName.value}</span>
      </div>
    );

    return (
      <div className="tfMeasuremnet">
        <div className="checkFormWrapper">
          <FormTitle
            title="Product Information"
            description=""
          />

          <form className="checkform" onSubmit={e => {e.preventDefault()}}>
            <div>
              <MuiRadio
                options={this.state.socketMaterials.map((option) => ({
                  displayName: option.displayName,
                  id: option.id,
                  partNumbers: option.partNumbers,
                  content: (option.id === this.fromCADFileId) ? cadFileUploader : ""
                }))}
                label="Socket Material"
                defaultValue={this.state.formState.socketMaterial.value}
                required={this.state.formState["socketMaterial"].isRequired}
                error={
                  this.handleError("socketMaterial") && this.state.isSubmit
                }
                onChange={(e) => {
                  this.props.setActiveInnerStep(0);
                  if (parseInt(e.target.value) !== this.fromCADFileId) {
                    this.removeFile();
                  } else {
                    this.addFile();
                  }
                  this.onRadioChange(e, "socketMaterial");
                }}
              />
            </div>

            <div>
              <MuiRadio
                options={this.state.suspensionOptions}
                label="Suspension"
                defaultValue={this.state.formState.suspension.value}
                required={this.state.formState["suspension"].isRequired}
                error={
                  this.handleError("suspension") && this.state.isSubmit
                }
                onChange={(e) => {
                  this.props.setActiveInnerStep(1);
                  this.onRadioChange(e, "suspension");
                }}
              />
            </div>

            <div>
              <MuiRadio
                options={this.state.trimlineOptions}
                label="Posterior Trim Line Options"
                defaultValue={this.state.formState.trimline.value}
                required={this.state.formState["trimline"].isRequired}
                error={
                  this.handleError("trimline") && this.state.isSubmit
                }
                onChange={(e) => {
                  this.props.setActiveInnerStep(2);
                  this.onRadioChange(e, "trimline");
                }}
              />
            </div>

            <div className="msgBox fieldBorder msgBoxWidth">
              <div className="possibelDate">
                <div>
                  <h4 className="headLable"><b>Earliest Ship Date</b>: {this.formatShipDate(this.state.estimatedShipDate)}</h4>
                </div>
              </div>
              <InputTextField
                label="Items sent with Order"
                variant="outlined"
                placeholder={`Type Something here, please keep notes under ${MaxInputLength} characters...`}
                type="text"
                width="800px"
                multiline
                rows={6}
                value={this.state.formState.itemsSentIn.value}
                required={this.state.formState["itemsSentIn"].isRequired}
                error={this.handleError("itemsSentIn") && this.state.isSubmit}
                onChange={(e) => {
                  this.onInputChange(e, "itemsSentIn");
                  this.props.setActiveInnerStep(3);
                }}
              />
            </div>

            <div className="msgBox fieldBorder msgBoxWidth">
              <h4 className="headLable"> Notes</h4>
              <InputTextField
                label="Other Notes"
                variant="outlined"
                placeholder={`Type Something here, please keep notes under ${MaxInputLength} characters...`}
                type="text"
                width="800px"
                multiline
                rows={6}
                value={this.state.formState.notes.value}
                error={this.handleError("notes") && this.state.isSubmit}
                onChange={(e) => {
                  this.onInputChange(e, "notes");
                  this.props.setActiveInnerStep(4);
                }}
              />
            </div>

            <div className="fieldBorder">
              <div className="msgBox msgBoxWidth">
                <h4 className="headLable"><b>Socket Finish:</b></h4>
                <p>{this.defaults.socketFinish.name}</p>
              </div>
            </div>

          </form>
        </div>
        <div className="handelButtons">
          <SecondaryButton
            text="Save As Draft"
            onClick={this.props.handleClickOpen}
          />
          <SecondaryButton
            text = "Clear the Order?"
            onClick = {this.props.handleClickClearOpen}
          />            
          <div className="stepBtn">
            <SecondaryButton
              text="Back"
              onClick={() => this.props.handleBack(this.props.currentIndex - 1)}
              disabled={
                this.props.activeOuterStep === 0 && this.props.innerStep === 0
              }
            />
            <Button
              text="Next"
              disabled={this.state.isLoading}
              onClick={async () => {
                const checkNotesLength = AreNotesLessThanMaxLength([  {note: this.state.formState.notes?.value, name: "Other Notes"}, {note: this.state.formState.itemsSentIn?.value, name: "Items sent with Order"}]);
                if (checkNotesLength.length > 0) {
                  CreateNotification(`'${checkNotesLength[0]}' field has exceeded character limit of ${MaxInputLength}`, "error");
                } else {
                  this.setState({ isLoading: true });
                  this.saveData();
                }
              }}
            />
          </div>
        </div>
        <SaveAsDraft
          open={this.props.open}
          handleClose={this.props.handleClose}
          showSubmit={this.props.showSubmit}
          setShowSubmit={this.props.setShowSubmit}
        />
        <ClearOrder
          openClear={this.props.openClear}
          handleCloseClear={this.props.handleCloseClear}
          showClear={this.props.showClear}
          setShowClear={this.props.setShowClear}
          formId = {this.props.formTypeId}
          handleClearBack={this.props.handleClearBack}
        />        
      </div>
    );
  }
  isRevoFitEnabled() {
    return this.state.formState.revoFitEnabled.value;
  }

  isAdditionalWindowSelected() {
    return this.state.formState.revoFit.value[this.additionalWindowId];
  }


  isPRSOption(option) {
    return option.includes("PRS");
  }

}

export default XtremityMeasurement;